module.exports = __webpack_public_path__ + "static/img/Brussel.7f75e48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brussel.jpg
// module id = HR7W
// module chunks = 1